var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-row-center-center",class:[_vm.boder, `${_vm.pointer ? 'cursor-pointer' : ''}`],style:({width: `${_vm.width}px`, height: `${_vm.height}px`, background: `${_vm.bg}`, borderRadius: `${_vm.bradius}px`})},[_c('span',{style:({'fontSize': _vm.fz + 'px', 'color': _vm.color})},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }